import React from 'react'

export default function IconNonLink ({ src, className }) {
  return (
        <div className={`border rounded sm:rounded-lg hover:opacity-80 w-10 h-10 flex justify-center items-center ${className}`}>
          <img className="w-[14px] sm:w-5" src={src} alt="" />
        </div>
  )
}
